"use strict";

exports.__esModule = true;
exports["default"] = findAllParents;

var _constants = require("../constants");

/**
 * Find all parent nodes of a node
 */
function findAllParents(rowData, rowKey) {
  var parents = [];

  if (!rowData) {
    return parents;
  }

  function findParent(data) {
    if (data) {
      parents.push(data[rowKey]);

      if (data[_constants.PARENT_KEY]) {
        findParent(data[_constants.PARENT_KEY]);
      }
    }
  }

  findParent(rowData[_constants.PARENT_KEY]);
  return parents;
}